export const getPlaceholderName = (name = "") => {
    return name.split(" ").slice(0, 2).map((word) => word.charAt(0).toUpperCase()).join("");
  };

export function getValueType(value) {
    const rawType = typeof value;
    if (rawType === 'object') {
      if (value === null) return 'null';
      return 'object';
    }
    return rawType;
  }